<template>
    <vgloballayout
        :loading="loading"
        :error="error"
        @reload="loadInfo"
    >
        <div slot=body>
            <h1>Настройки сайта</h1>
            <el-row type="flex" justify="space-between p-t-45">
                <el-col :span="2" class="p-t-5"><span>Шаблон</span></el-col>
                <el-col :span="19">
                    <el-select v-model="dataSet.template" placeholder="Выберите шаблон" @change="setOrganizationSettings">
                        <el-option
                            v-for="item in options"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value"
                            >
                        </el-option>
                    </el-select>
                </el-col>
            </el-row>

            <el-row type="flex" justify="space-between p-t-45">
                <el-col :span="2" class="p-t-5"><span>Логотип</span></el-col>
                <el-col :span="19">
                    <div style="margin-bottom: 30px" v-if="dataSet.logoImageName != null">
                        <img :src="getUrlLogo" width="200px" />
                    </div>
                    <el-upload
                        :show-file-list="false"
                        :on-success="handleAvatarSuccessLogo"
                        :before-upload="beforeLogoUpload"
                        :action="url"
                        with-credentials
                        >
                        <el-button slot="trigger" size="small" type="primary">Выбрать файл</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="success" @click="setOrganizationSettings">Сохранить</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="danger" @click="deleteLogo">Удалить</el-button>
                        <div class="el-upload__tip" slot="tip">Файл должен быть в формате png, и не превышать 1мб</div>
                    </el-upload>

                </el-col>
            </el-row>

            <el-row type="flex" justify="space-between p-t-45">
                <el-col :span="2" class="p-t-5"><span>Фон</span></el-col>
                <el-col :span="19">
                    <div style="margin-bottom: 30px;" v-if="dataSet.backgroundImageName != null">
                        <img style="border-radius: 3px;" :src="getUrlBack" width="300px" /> 
                    </div>

                    <el-upload
                        :show-file-list="false"
                        :on-success="handleAvatarSuccessBack"
                        :before-upload="beforeBackUpload"
                        :action="url"
                        with-credentials
                    >
                        <el-button slot="trigger" size="small" type="primary">Выбрать файл</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="success" @click="setOrganizationSettings">Сохранить</el-button>
                        <el-button style="margin-left: 10px;" size="small" type="danger" @click="deleteBackground">Удалить</el-button>
                        <div class="el-upload__tip" slot="tip">Файл должен быть в формате png или jpeg, и не должен превышать 1мб</div>
                    </el-upload>

                </el-col>
            </el-row>

        </div>
    </vgloballayout>
</template>

<script>
import { BASE_URL } from '@/plugins/url-env'

export default {
    data() {
        return {
            loading: false,
            loadingSub: false,
            error: false,
            options: [
                {
                    value: 'template-1',
                    label: 'Шаблон 1'
                },
                {
                    value: 'template-2',
                    label: 'Шаблон 2'
                },
            ],
            dataSet: {
                template: 'template-1',
                logoImageName: null,
                backgroundImageName: null
            },
            url: BASE_URL + '/LocalStorage/Upload',
        }
    },

    mounted() {
        this.loadInfo()
    },
    
    computed: {
        getUrlLogo() {
            return `${BASE_URL}/${this.dataSet.logoImageName}`
        },
        getUrlBack() {
            return `${BASE_URL}/${this.dataSet.backgroundImageName}`
        },
    },

    methods: {
        deleteLogo() {

        },
        deleteBackground() {

        },
        handleAvatarSuccessLogo(res, file) {
            this.dataSet.logoImageName = res.file
        },
        handleAvatarSuccessBack(res, file) {
            this.dataSet.backgroundImageName = res.file
        },

        beforeLogoUpload(file) {
            const isJPG = file.type === 'image/png';
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('Только PNG формат');
            }
            if (!isLt2M) {
                this.$message.error('Изображение не должно превышать 2 мб');
            }
            return isJPG && isLt2M;
        },

        beforeBackUpload(file) {

            const isJPG = file.type === 'image/png' || file.type === 'image/jpeg'
            const isLt2M = file.size / 1024 / 1024 < 2;

            if (!isJPG) {
                this.$message.error('Только jpeg или PNG формат');
            }
            if (!isLt2M) {
                this.$message.error('Изображение должно быть менее 1 МБ');
            }
            return isJPG && isLt2M;
        },

        async loadInfo() {
            this.loading = true
            this.error = false

            try {
                let query = await this.$store.dispatch('getOrganizationSettings')
                
                this.dataSet.template = query.template
                this.dataSet.logoImageName = query.logoImageName
                this.dataSet.backgroundImageName = query.backgroundImageName
            } catch(e) {
                this.error = this.$ErrorsMod(e)
            }

            this.loading = false
        },

        async setOrganizationSettings() {

            this.loadingSub = true

            try {
                await this.$store.dispatch('setOrganizationSettings', this.dataSet)
                
                this.$message({
                    message: ' Настроки обновлены',
                    type: 'success'
                });
            } catch(e) {
                this.$ErrorsMod(e)
            }

            this.loadingSub = false
        }
    }
}
</script>
<style>
  .avatar-uploader .el-upload {
    border: 1px dashed #d9d9d9;
    border-radius: 6px;
    cursor: pointer;
    position: relative;
    overflow: hidden;
  }
  .avatar-uploader .el-upload:hover {
    border-color: #409EFF;
  }
  .avatar-uploader-icon {
    font-size: 28px;
    color: #8c939d;
    width: 178px;
    height: 178px;
    line-height: 178px;
    text-align: center;
  }
  .avatar {
    width: 178px;
    height: 178px;
    display: block;
  }
</style>